import { useTranslation } from "react-i18next";
import { Activity } from "../types";
import { ActivityDate } from "./ActivityDate";
import { ActivityRow } from "./ActivityRow";

export function ActivityList({ activitiesByDate } : { activitiesByDate: Map<string, Activity[]> }) {
  const { t } = useTranslation();

  return (
    <div className="activities-list">
      {activitiesByDate && activitiesByDate.size > 0 ? (
        Array.from(activitiesByDate)?.map(([date, activities]) => (
          <div key={date}>
            <ActivityDate date={date} />
            {activities.map((activity, index, arr) => (
              <>
                <ActivityRow key={activity.id} activity={activity} />
                {arr.length - 1 !== index &&
                  <div className="separator"></div>}
              </>
            ))}
          </div>
        ))
      ) : (
        <div className="no-activity">
          {t('no_activity_for_period')}
        </div>
      )}
    </div>
  )
}